module.exports = __webpack_public_path__ + "img/38.014193a9.jpg";